import internalApi from "../axios/internalApi";
import { message } from "antd";

// Create a new event
export const createEvent = async (eventData) => {
  try {
    const response = await internalApi.post(
      { server: "api/v1/", path: "admin/event" },
      eventData
    );
    return response;
  } catch (error) {
    console.error("Error creating event:", error);
    message.error(error?.data?.message);
    throw error;
  }
};

// Update an existing event
export const updateEvent = async (id, eventData) => {
  try {
    const response = await internalApi.patch(
      { server: "api/v1/", path: `admin/event/${id}` },
      eventData
    );
    return response;
  } catch (error) {
    console.error("Error updating event:", error);
    message.error(error?.data?.message);
    throw error;
  }
};

// Fetch all events
export const fetchEvents = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.pageNumber) queryParams.append("pageNumber", params.pageNumber);
    if (params.itemPerPage) queryParams.append("itemPerPage", params.itemPerPage);
    if (params.isActive !== undefined) queryParams.append("isActive", params.isActive);
    
    const response = await internalApi.get({
      server: "api/v1/",
      path: `admin/event/list?${queryParams.toString()}`,
    });
    return response;
  } catch (error) {
    console.error("Error fetching events:", error);
    message.error(error?.data?.message);
    throw error;
  }
};

// Delete an event
export const deleteEvent = async (id) => {
  try {
    const response = await internalApi.delete({
      server: "api/v1/",
      path: `admin/event/${id}`,
    });
    return response;
  } catch (error) {
    console.error("Error deleting event:", error);
    message.error(error?.data?.message);
    throw error;
  }
};

// Update event status
export const updateEventStatus = async (id, isActive) => {
  try {
    const response = await internalApi.patch(
      { server: "api/v1/", path: `admin/event/${id}/status` },
      { isActive }
    );
    return response;
  } catch (error) {
    console.error("Error updating event status:", error);
    message.error(error?.data?.message);
    throw error;
  }
};

// Fetch default images for event image bank
export const fetchEventImageBankDefaults = async () => {
  try {
    const response = await internalApi.get({
      server: "api/v1/",
      path: "admin/event/image-bank/defaults",
    });
    return response;
  } catch (error) {
    console.error("Error fetching event image bank defaults:", error);
    // Don't show error message - defaults are optional
    return { data: [] };
  }
};
